import { createSelector } from 'reselect'
import { IStore } from '../../index'

export function getAccessToken(state: IStore): string {
  return state.userAccount.credentials.accessToken || ''
}

export const isUserAuthorized = createSelector(
  [getAccessToken],
  accessToken => accessToken !== '',
)

export function getIsAuthorizing(state: IStore): boolean {
  return state.userAccount.isAuthorizing
}
